/**
 * Theme config for ComparisonBarGraphStyled.
 * When stripeColor is set, bars are drawn with diagonal stripes; otherwise solid fill.
 */
export interface BarTheme {
  barColor: string
  stripeColor?: string
  labelLines: string[]
}

export interface ComparisonBarGraphThemeConfig {
  topCornerRadius: number
  regular: BarTheme
  direct: BarTheme
  axisLineStroke?: string
}

export type ComparisonBarGraphVariant = 'default' | 'regularVsDirectReturns'

/** Theme for Regular vs Direct returns: dark gray/orange bars with diagonal stripes */
export const THEME_REGULAR_VS_DIRECT_RETURNS: ComparisonBarGraphThemeConfig = {
  topCornerRadius: 8,
  regular: {
    barColor: '#3D3D3D',
    stripeColor: '#656464',
    labelLines: ['Your Regular', "Fund's Returns"]
  },
  direct: {
    barColor: '#CC5C2D',
    stripeColor: '#B74210',
    labelLines: ['Direct', "Fund's Returns"]
  },
  axisLineStroke: '#E77464'
}
